import scrollIntoViewIfNeeded from "../polyfills/scrollIntoViewIfNeeded"

export default class Carousel {
   constructor(target = ".carousel", trackTarget = ".carousel-inner", slideName = ".carousel-slide", onPageChange = () => {}) {
        this.carousel = document.querySelector(target)
        if (!this.carousel) return null;
        this.carouselInner = this.carousel.querySelector(trackTarget)
        this.carouselSlides = this.carouselInner.querySelectorAll(slideName)
        this.carouselSlideSize = this.carouselInner.querySelector(slideName).clientWidth
        this.carouselPagesContainer = this.carousel.querySelector(".carousel-pages")
        this.carouselPages = this.carouselPagesContainer.querySelectorAll(".carousel-page")
        this.currentSlideIndex = 0
        this.onPageChange = onPageChange

        this.carouselPages[this.currentSlideIndex].classList.add("active")

        this.render()

        return this
   }

    scrollToPage(page) {
        let slide = this.carouselSlides[page]

        if (!slide) return

        if (slide.scrollIntoViewIfNeeded) {
            slide.scrollIntoViewIfNeeded()
        } else {
            slide.scrollIntoView()
        }

        this.carouselPages.forEach((el, index) => {
            el.classList.remove("active")

            if (page === index) {
                el.classList.add("active")

                this.onPageChange(el)
            }
        })
    }

    scrollToNextPage = (e) => {
        e?.preventDefault()
        this.currentSlideIndex = this.currentSlideIndex + 1 >= this.carouselSlides.length ? 0 : this.currentSlideIndex + 1

        this.scrollToPage(this.currentSlideIndex)
    }

    scrollToPrevPage = (e) => {
        e.preventDefault()
        this.currentSlideIndex = this.currentSlideIndex - 1 < 0 ? this.carouselSlides.length - 1 : this.currentSlideIndex - 1

        this.scrollToPage(this.currentSlideIndex)
    }

    render() {
        this.carouselPages.forEach((el, page) => {
            el.addEventListener("click", e => {
                e.preventDefault()

                this.scrollToPage(page)
            })
        })

        this.carousel.querySelector(".carousel-next")?.addEventListener("click", this.scrollToNextPage)
        this.carousel.querySelector(".carousel-prev")?.addEventListener("click", this.scrollToPrevPage)
    }
}
